import React from 'react';
import Header from './components/Header';
import WorkExperience from './components/WorkExperience';
import Projects from './components/Projects';
import Education from './components/Education';
import Skills from './components/Skills';
import Sidebar from './components/Sidebar';

const App = () => {
  return (
    <div className="min-h-screen bg-paper text-ink font-sans">
      <a
        href="#experience"
        className="sr-only focus:not-sr-only focus:absolute focus:left-4 focus:top-4 focus:z-50 focus:bg-surface focus:px-3 focus:py-2 focus:text-sm"
      >
        Skip to content
      </a>
      <Sidebar />
      <main className="mx-auto max-w-site px-5 py-12 sm:px-8 sm:py-16 md:py-20">
        <Header />
        <div className="mt-20 space-y-20 sm:mt-28 sm:space-y-24 md:mt-32 md:space-y-28">
          <WorkExperience />
          <Projects />
          <Education />
          <Skills />
        </div>
        <footer className="mt-24 text-sm text-muted sm:mt-32">
          Zachary Klein · Medford, MA
        </footer>
      </main>
    </div>
  );
};

export default App;
